import 'custom-event-polyfill';
import Cookie from 'js.cookie';
import 'lightgallery/dist/js/lightgallery.js';
import 'lg-fullscreen/dist/lg-fullscreen.js';
import 'lg-thumbnail/dist/lg-thumbnail.js';
import 'lg-zoom/dist/lg-zoom.js';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if (!Cookie.get('alert') && $('#modal').length) {
      $('#modal').show();
    }
    
    $('.modal .btn-close').click(function() {
      $('#modal').hide();
      Cookie.set('alert', true, {
        expires: 1,
      });
    });

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('is-active');
      $('#sideNav').toggleClass('sideNav-open');
      $('.sideNavBody').toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $('.sideNav').click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
        $('.hamburger').removeClass('is-active');
        $('#sideNav').removeClass('sideNav-open');
        $('.sideNavBody').removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });
    
        if ($('.testimonials-carousel').length) {
          $('.testimonials-carousel').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            appendArrows: '.testimonials-panel .slider-nav',
            appendDots: '.testimonials-panel .slider-nav',
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: 1439,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  arrows: false,
                },
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                },
              },
            ],
          });
        }
        $('#photo-gallery').lightGallery({
          selector: '#photo-gallery .gallery-image',
        });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js